import { useMemo } from 'react';
import useSWR from 'swr';

import { cheryInstance } from '@/api';
import { TModel } from '@/types/common';

export type TModelImages = {
  icon: string;
  menu: string;
  images360: any[];
};

export type TModelData = {
  code: string;
  creditFrom: string;
  images: TModelImages;
  instockLink: string;
  name: string;
  subtitle: string;
  text: string;
  title: string;
};

const getModels = async endpoint => {
  const { data } = await cheryInstance.get<Record<string, TModelData>>(endpoint);
  return data;
};

const useModelDataFetch = () => {
  const { data: modelData, error } = useSWR(`models/index.json`, getModels);

  const models = useMemo(() => {
    if (!modelData) return [];
    return Object.values(modelData).map((model, index) => {
      return {
        id: index,
        title: model.name,
      } as TModel;
    });
  }, [modelData]);

  return { data: { models }, loading: !modelData, error };
};

export default useModelDataFetch;
